export default __webpack_public_path__ + "static/media/coin-pile.dbcedcbd.svg";